import { FC } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { RightDrawer } from 'baby-design'

import { useReservation } from 'src/routes/(registry)/api/reservations'
import { Reservation } from 'src/types/reservation'
import GiftActions from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer/GiftActions/GiftActions'
import GiftSummary from './GiftSummary'
import OrderDetails from './OrderDetails'

import css from './GiftDetailsDrawer.styles.scss'

const Section: FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={css.GiftDetailsDrawer__Section}>{children}</div>
)

export const Contents: FC<{
  reservation: Reservation
}> = ({ reservation }) => (
  <div
    className={css.GiftDetailsDrawer}
    data-testid="GiftDetailsDrawer__Contents"
  >
    <Section>
      <GiftSummary reservation={reservation} />
    </Section>
    <Section>
      <OrderDetails reservation={reservation} />
    </Section>
    <Section>
      <GiftActions reservation={reservation} />
    </Section>
  </div>
)

export const ContentsInDrawer: FC<{ reservationToken: string }> = ({
  reservationToken,
}) => {
  const modal = useModal()
  const { data: reservation, isSuccess } = useReservation(reservationToken)

  return (
    <RightDrawer
      handleClose={modal.hide}
      handleDismount={modal.remove}
      isOpen={modal.visible}
      title="Gift details"
    >
      {isSuccess && reservation && <Contents reservation={reservation} />}
    </RightDrawer>
  )
}

const GiftDetailsDrawer = NiceModal.create(ContentsInDrawer)

export const showGiftDetailsDrawer = ({
  reservationToken,
}: {
  reservationToken: string
}) => NiceModal.show(GiftDetailsDrawer, { reservationToken })

export default GiftDetailsDrawer
